import angular from 'angular';
import { AddressAptNeededValidator } from './apt-needed.validator';
import { AddressAptNotFoundValidator } from './apt-not-found.validator';
import { AddressCommercialFromValidator } from './commercial-from.validator';
import { AddressCommercialToValidator } from './commercial-to.validator';
import { AddressMilitaryValidator } from './military.validator';
import { AddressInvalidValidator } from './invalid.validator';
import { AddressRequiredValidator } from './required.validator';
import { AddressDuplicateValidator } from './duplicate.validator';

export const AddressValidatorsModule = angular
  .module('angular-common.address.validators', [])
  .directive('updAddressAptNeeded', AddressAptNeededValidator)
  .directive('updAddressAptNotFound', AddressAptNotFoundValidator)
  .directive('updAddressCommercialFrom', AddressCommercialFromValidator)
  .directive('updAddressCommercialTo', AddressCommercialToValidator)
  .directive('updAddressMilitary', AddressMilitaryValidator)
  .directive('updAddressInvalid', AddressInvalidValidator)
  .directive('updAddressRequired', AddressRequiredValidator)
  .directive('updAddressDuplicate', AddressDuplicateValidator);
